// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './routers'

import 'babel-polyfill'

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

// iView
import iView from 'iview'
import 'iview/dist/styles/iview.css'
Vue.use(iView)


// 引入通用公共样式
import "@/assets/less/base.css"
import "@/assets/less/app.css"

// 引入commonjs
import commonJs from '@/assets/js/common.js'
Vue.prototype.common = commonJs

// ajax数据请求插件
import axios from 'axios'
Vue.prototype.$ajax = axios

import Qs from 'qs'
Vue.prototype.$qs = Qs

Vue.config.productionTip = false

// 日期过滤器
Vue.filter('newData', function (value) {
    if(value == undefined) {
        return ""
    }
    var unixTimestamp = new Date( value*1000 ) ;
    var mon = (unixTimestamp.getMonth()+1)< 10 ? '0'+ (unixTimestamp.getMonth()+1) : (unixTimestamp.getMonth()+1)
    var day = (unixTimestamp.getDate())< 10 ? '0'+unixTimestamp.getDate() : unixTimestamp.getDate()
    var hours = (unixTimestamp.getHours())< 10 ? '0'+unixTimestamp.getHours() : unixTimestamp.getHours()
    var minutes = (unixTimestamp.getMinutes())< 10 ? '0'+unixTimestamp.getMinutes() : unixTimestamp.getMinutes()
    // return unixTimestamp.getFullYear() + "-" + (mon) + "-" + day + " " + hours + ":" + minutes;
    return unixTimestamp.getFullYear() + "-" + (mon) + "-" + day
})
// 价格过滤器
Vue.filter('floorMoneyFormat', function (value) {
    if(value == undefined) {
        return ""
    }
    return "￥"+Math.round(value*100)/100;
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js